import React, { Fragment, useEffect, useState } from 'react'
import {
  Grid,
  Typography,
  Button,
  
  
  
  IconButton,
  Box,
  CircularProgress
} from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { PickingRouteStatusItem } from '../../../interfaces/WorkOrder/WorkOrder'
import { State, Status } from '../../../hooks/useFetchState'
import { ValidationStatusPickingRoutes } from './ValidationStatusPickingRoutes'
import { ApiResponse } from '../../../typings/ApiResponse'
import { OrderLabelInfoDto } from '../../../interfaces/OrderLabel'

import InfoIcon from '@mui/icons-material/Info'
import { Modal } from '../../_EOS/Modal'
import { LabelError } from './typings'
import { useApi } from '../../../hooks/useApi'
import { createWorkOrderBlog, getTemporalLabel, patchOrderLabel } from './api'
import { Loading } from '../../UI'
import { eValidationStatus } from '../../../enums/eValidationStatus'

interface PickingUsingExternalCourierLabelProps {
  error: LabelError | undefined
  pickingRoutesState: State<PickingRouteStatusItem[]>
  orderLabelState: State<ApiResponse<OrderLabelInfoDto>>
  matched: boolean
  setShowPDF: (isOpen: boolean) => void
  setShowTemporalLabel: (isOpen: boolean) => void
  setOpenPackageQuantityModal: (isOpen: boolean) => void
  showBulkButton: boolean
  setTemporalLabel: (label: string) => void
  pickingRouteId: number
  handleSnackbar: (message: string, success: boolean) => void
  showCourierLabel: boolean
  fetchOrderLabelData: (workOrderId: number) => void
  handleShowLabelButton: (value: boolean) => void
  executeGetLabelCourier: boolean
}

export const PickingUsingExternalCourierLabel: React.FC<
  PickingUsingExternalCourierLabelProps
> = ({
  error,
  pickingRoutesState,
  matched,
  orderLabelState,
  setShowPDF,
  setOpenPackageQuantityModal,
  showBulkButton,
  setShowTemporalLabel,
  setTemporalLabel,
  pickingRouteId,
  handleSnackbar,
  showCourierLabel,
  fetchOrderLabelData,
  handleShowLabelButton,
  executeGetLabelCourier
}) => {
  const [isLoadComplete, setisLoadComplete] = useState(false)
  const [loadingTemporalLabel, setLoadingTemporalLabel] = useState(false)
  const classes = useStyles()

  const [isOpenPickingStatusModal, setOpenPickingStatusModal] = useState(false)
  const { state: stateWOBlog, callApi } =
    useApi<ApiResponse<OrderLabelInfoDto>>()
  const { state: statePatch, callApi: patchOrderLabelApi } = useApi()
  const { state: requestFileState, callApi: reqGetTemporalLabel } = useApi()

  // valida que todas las rutas estan en finalizadas
  const pickingRoutes = pickingRoutesState.data
  const allRoutesValidated = pickingRoutes
    ? pickingRoutes.length === 1 ||
      pickingRoutes.every(
        (el) => el.validationStatusId === eValidationStatus.Finished
      )
    : false

  const hasMultipleUnvalidatedRoutes =
    pickingRoutes && pickingRoutes.length > 1 && !allRoutesValidated

  // Si recibimos registros de etiqueta y el estado = 3 (solicitud finalizada, deberiamos tener un link de la etiqueta)
  // Además al solicitud debe ser para uno o más bultos
  const shouldShowRequestedLabelMessage =
    orderLabelState.data?.items !== undefined &&
    orderLabelState.data?.items.length > 0 &&
    orderLabelState.data?.items[0].statusId === 3 &&
    orderLabelState.data?.items[0].orderLabelUrl

  // Valida que no exista etiqueta
  const shouldTemporalLabelAppear =
    !orderLabelState.data?.items ||
    orderLabelState.data?.items.length <= 0 ||
    !orderLabelState.data?.items[0].orderLabelUrl ||
    hasMultipleUnvalidatedRoutes // si tienes multiples rutas sin validar queda en true

  // Valida si se cargaron los items
  const loadItems = orderLabelState.data?.items

  const [isOpenRequestLabelMessage, setIsOpenRequestLabelMessage] =
    useState(false)

  const workOrderBlog = async (workOrderId: number) => {
    await callApi(
      createWorkOrderBlog({
        workOrderId: workOrderId,
        comments: 'Ver etiqueta'
      })
    )
  }

  const updateOrderLabel = async (orderLabelId: number) => {
    await patchOrderLabelApi(patchOrderLabel(orderLabelId))
    // Registra la petición en la bitácora de OT de Salida
    await workOrderBlog(orderLabelState.data?.items[0].workOrderId || 0)

    fetchOrderLabelData(orderLabelState.data?.items[0].orderId || 0)
    setShowPDF(true)
  }

  const handleViewOrderLabel = async () => {
    setIsOpenRequestLabelMessage(false)
    // Actualiza el usuario que quiere ver la etiqueta
    await updateOrderLabel(orderLabelState.data?.items[0].orderLabelId || 0)
  }

  const requestGetTemporalLabel = () => {
    setLoadingTemporalLabel(true)
    reqGetTemporalLabel(getTemporalLabel(pickingRouteId))
      .then((response) => {
        setTemporalLabel(response)
        setShowTemporalLabel(true)
      })
      .catch((error) => {
        handleSnackbar('Error al obtener la etiqueta temporal: ' + error, false)
      })
      .finally(() => setLoadingTemporalLabel(false))
  }

  useEffect(() => {
    if (
      requestFileState.status !== Status.Loading ||
      orderLabelState.status !== Status.Loading ||
      statePatch.status !== Status.Loading ||
      stateWOBlog.status !== Status.Loading
    ) {
      setisLoadComplete(true) // determina que se cargo todo, para dejar imprimir etiqueta courier
    }
  }, [orderLabelState.status, stateWOBlog, statePatch, requestFileState])

  // asigna valor para mostrar o ocultar el botón de imprmir en el componente PickingValidatePage.tsx
  useEffect(() => {
    handleShowLabelButton(!shouldTemporalLabelAppear || false) // en caso de undefined deja false
  }, [shouldTemporalLabelAppear])

  useEffect(() => {
    // detecta si se ejecuto el boton imprimir en el componente padre para mostrar etiqueta courier
    // solo si el componente termino de cargar todo
    if (isLoadComplete) {
      if (shouldShowRequestedLabelMessage) {
        setIsOpenRequestLabelMessage(true)
      } else {
        setShowPDF(true)
      }
    }
  }, [executeGetLabelCourier])

  return (
    <Fragment>
      {isLoadComplete && (
        <Grid container item xs={12} md={6} justifyContent='flex-end'>
          {matched && <Typography>Etiqueta transportista</Typography>}
          {error !== undefined && (
            <Box display={'flex'} alignItems={'center'}>
              <Typography variant='body2' className={classes.errorMessage}>
                {error.errorDescription}
              </Typography>
              {error.typeError === 'PICKINGROUTES_WITHOUT_VALIDATION' && (
                <IconButton>
                  <InfoIcon />
                </IconButton>
              )}
            </Box>
          )}

          <Grid container direction='column' spacing={1}>
            {showCourierLabel && (
              <Grid item>
                <Button
                  variant='contained'
                  color='primary'
                  fullWidth
                  disabled={
                    !shouldTemporalLabelAppear ||
                    !loadItems ||
                    loadingTemporalLabel // loading del request api.
                  }
                  onClick={() => requestGetTemporalLabel()}
                >
                  {loadingTemporalLabel ? (
                    <CircularProgress size={14} />
                  ) : (
                    'Generar etiqueta provisoria'
                  )}
                </Button>
              </Grid>
            )}
            {showCourierLabel && !showBulkButton && (
              <Grid item>
                <Button
                  variant='contained'
                  color='primary'
                  fullWidth
                  disabled={shouldTemporalLabelAppear || !loadItems}
                  onClick={() => setOpenPackageQuantityModal(true)}
                >
                  + Bultos
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
      {!isLoadComplete && <Loading />}
      <Modal
        onClose={() => setOpenPickingStatusModal(false)}
        open={isOpenPickingStatusModal}
        maxWidth={'xs'}
      >
        {pickingRoutesState.status === Status.Success && (
          <ValidationStatusPickingRoutes
            pickingRouteStatus={pickingRoutesState.data}
          />
        )}
      </Modal>
      {shouldShowRequestedLabelMessage && (
        <Modal
          onClose={() => setIsOpenRequestLabelMessage(false)}
          open={isOpenRequestLabelMessage}
          title='Imprimir Etiqueta'
          maxWidth='xs'
          cancelButton={{
            title: 'Cancelar',
            action: () => setIsOpenRequestLabelMessage(false)
          }}
          successButton={{
            title: 'Aceptar',
            action: () => handleViewOrderLabel()
          }}
        >
          {orderLabelState.data?.items[0].createdByUser ? (
            <Box className={classes.modalBox}>
              <Typography variant='body1'>
                La etiqueta ya ha sido solicitada anteriormente
                {' por el usuario: '}
                <strong>{orderLabelState.data?.items[0].createdByUser}</strong>
                <br />
                ¿Desea verla nuevamente?
              </Typography>
            </Box>
          ) : (
            <Box className={classes.modalBox}>
              <Typography variant='body1'>¿Desea ver la etiqueta?</Typography>
            </Box>
          )}
        </Modal>
      )}
    </Fragment>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      [theme.breakpoints.up('md')]: {
        marginLeft: '5px'
      }
    },
    errorMessage: {
      color: 'red',
      verticalAlign: 'center'
    },
    dispatchValidationError: {
      color: '#ED4337'
    },
    modalBox: {
      padding: '50px',
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
      flexDirection: 'column'
    }
  })
)
